export const PRETTO_BASE_URL = "https://reassurez-moi.app.pretto.fr/project/maturity"

export const PRETTO_UTM_PARAMS: Readonly<Record<string, string>> = {
    utm_source: "strategique",
    utm_medium: "partner",
    utm_campaign: "reassurez_moi",
}

export const PRETTO_UTM_CONTENT = {
    FEATURED_RATES: "featured_rates_cta",
    BANK_TABLE: "bank_table_cta",
    JOURNEY: "pretto_journey_cta",
    HEADER: "header_menu_cta",
    HEADER_MOBILE: "header_menu_cta_mobile",
} as const

export const PRETTO_UTM_TERM = {
    TAUX_PRET: "taux_pret",
    PRET_IMMOBILIER: "pret_immobilier",
} as const

export interface PrettoUtmContext {
    content: string
    term: string
}

export type PrettoMaturityKind = "CAPACITY" | "PURCHASE"

export interface PrettoJourneyOption {
    id: string
    icon: string
    title: string
    text: string
    kind: PrettoMaturityKind
}

export const PRETTO_JOURNEY_OPTIONS: ReadonlyArray<PrettoJourneyOption> = [
    {
        id: "UNDER_STUDY",
        icon: "fa-cloud",
        title: "Réflexion",
        text: "J'explore les possibilités",
        kind: "CAPACITY",
    },
    {
        id: "SEARCH_STARTED",
        icon: "fa-magnifying-glass",
        title: "Recherche active",
        text: "Je visite des biens",
        kind: "CAPACITY",
    },
    {
        id: "OFFER_MADE",
        icon: "fa-file-pen",
        title: "Offre d'achat faite",
        text: "Elle est en cours d'examen",
        kind: "PURCHASE",
    },
    {
        id: "OFFER_ACCEPTED",
        icon: "fa-circle-check",
        title: "Offre acceptée",
        text: "Le vendeur a dit oui",
        kind: "PURCHASE",
    },
    {
        id: "SALE_AGREEMENT_SIGNED",
        icon: "fa-house",
        title: "Compromis signé",
        text: "Le compromis est en cours",
        kind: "PURCHASE",
    },
]

export const PRETTO_JOURNEY_ANCHOR_ID = "pretto-journey"
